import { useTranslate } from 'react-polyglot'
import { SIZE_GUIDE, SIZE_GUIDE_TYPE } from '~/data/dictionary'
import { SIZE_GUIDE_TYPES } from '~/lib/constants'

export default function useSizeGuideTable(data: string[], isRing: boolean, isShoes: boolean) {
  const t = useTranslate()

  const shoulderRow = data.includes(SIZE_GUIDE_TYPES.SHOULDERS) && {
    title: t(SIZE_GUIDE.SHOULDER),
    values: {
      cm: [38, 39, 40, 41, 42, 43, 44],
      inch: [15, 15, 16, 16, 17, 17, 17],
    },
  }

  const chestRow = data.includes(SIZE_GUIDE_TYPES.CHEST) && {
    title: t(SIZE_GUIDE.CHEST),
    values: {
      cm: [81, 85, 89, 93, 97, 101, 105],
      inch: [32, 34, 35, 37, 38, 40, 41],
    },
  }

  const waistRow = data.includes(SIZE_GUIDE_TYPES.WAIST) && {
    title: t(SIZE_GUIDE.WAIST),
    values: {
      cm: [61, 65, 69, 73, 77, 81, 85],
      inch: [24, 26, 27, 29, 30, 32, 34],
    },
  }

  const hipsRow = data.includes(SIZE_GUIDE_TYPES.HIPS) && {
    title: t(SIZE_GUIDE.HIPS),
    values: {
      cm: [88, 92, 96, 100, 104, 108, 112],
      inch: [35, 36, 38, 39, 41, 43, 44],
    },
  }

  const frRow = {
    title: 'FR',
    values: [34, 36, 38, 40, 42, 44, 46],
  }


  if (isRing) {
    return [
      {
        title: t(SIZE_GUIDE.RING),
        type: SIZE_GUIDE_TYPE.DEFAULT,
        rows: [
          {
            title: 'Nina Ricci',
            values: ['S', 'M', 'L'],
          },
          { title: 'FR', values: [50, 53, 56] },
          { title: 'US/UK', values: ['5 ¼', '6 ¼', '7 ½'] },
          { title: 'mm', values: [15.9, 16.9, 17.8] },
        ],
      },
    ]
  }

  if (isShoes) {
    return [
      {
        title: t(SIZE_GUIDE.SHOES),
        type: SIZE_GUIDE_TYPE.DEFAULT,
        rows: [
          { title: 'Nina Ricci', values: [36, 37, 38, 39, 40, 41] },
          { title: 'Italie', values: [36, 37, 38, 39, 40, 41] },
          { title: 'Europe', values: [36, 37, 38, 39, 40, 41] },
          { title: 'France', values: [37, 38, 39, 40, 41, '41/42'] },
          { title: 'UK', values: [3, 4, 5, 6, 7, 8] },
          { title: 'USA', values: [6, 7, 8, 9, 10, 11] },
          { title: 'CM', values: [28.1, 28.8, 29.5, 30.2, 30.9, 31.6] },
          { title: 'INCHES', values: [11.1, 11.3, 11.6, 11.9, 12.2, 12.4] }
        ],
      },
    ]
  }

  return (
    [
      {
        title: t(SIZE_GUIDE.TABLE_GUIDE_TITLE),
        type: SIZE_GUIDE_TYPE.DEFAULT,
        rows: [frRow, shoulderRow, chestRow, waistRow, hipsRow].filter(
          Boolean,
        ),
      },
      {
        title: t(SIZE_GUIDE.UNIVERSAL_TABLE_TITLE),
        type: SIZE_GUIDE_TYPE.SIZE_CONVERSION,
        rows: [
          {
            title: 'Nina Ricci',
            values: [
              'XS/34',
              'S/36',
              'M/38',
              'L/40',
              'XL/42',
              'XXL/44',
              'XXXL/46',
            ],
          },
          { title: 'FR', values: [34, 36, 38, 40, 42, 44, 46] },
          { title: 'IT', values: [36, 38, 40, 42, 44, 46, 48] },
          { title: 'UK', values: [4, 6, 8, 10, 12, 14, 16] },
          { title: 'US', values: [0, 2, 4, 6, 8, 10, 12] },
        ],
      },
    ]

  )
}